// extracted by mini-css-extract-plugin
module.exports = {"textInputArea":"TextInputArea_textInputArea__dGgD6","textInputAreaLabel":"TextInputArea_textInputAreaLabel__2QYoW","textInputAreaInput":"TextInputArea_textInputAreaInput__eLRtZ"};